<template>
  <div>
    <div class="level ml-5 mb-3">
      <div>
        <small class="mr-2">
          <font-awesome-icon :icon="['fas', 'caret-right']" />
          {{ productFormOptionItem.name }}
        </small>
        <small class="mr-2">S/ {{ productFormOptionItem.price }}</small>
      </div>
      <div>
        <b-tag
          v-if="productFormOptionItem.suggested"
          class="mr-1"
          type="is-success"
          >Sugerido</b-tag
        >
        <span v-if="productFormOptionItem.is_active">
          <b-tag type="is-success">Activo</b-tag>
        </span>
        <span v-else>
          <b-tag type="is-dark">Inactivo</b-tag>
        </span>
        <b-button
          class="ml-5"
          size="is-small"
          @click="isImageModalActive1 = true"
        >
          <font-awesome-icon :icon="['fas', 'edit']" />
        </b-button>
        <b-button
          class="ml-1"
          type="is-danger"
          size="is-small"
          @click="isImageModalActive2 = true"
        >
          <font-awesome-icon :icon="['fas', 'trash']" />
        </b-button>
      </div>
    </div>
    <b-modal :width="550" scroll="keep" v-model="isImageModalActive2">
      <div class="card">
        <div class="card-content py-5">
          <h3 class="is-size-4 has-text-weight-bold mb-5">
            Eliminar Grupo de Opción {{ option.name }}
          </h3>
          <hr />
          <div
            class="is-flex is-justify-content-flex-end w-full is-align-items-center"
          >
            <div>
              <Button
                variant="gray"
                @click.native="isImageModalActive2 = false"
                >Cancelar</Button
              >
            </div>
            <div class="ml-3">
              <Button
                variant="danger"
                :spinner="loading"
                @click.native="deleteProductFormOption"
                >Sí</Button
              >
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="isImageModalActive1" :width="468" scroll="keep">
      <div class="card">
        <div class="card-content py-5">
          <h3 class="is-size-4 has-text-weight-bold mb-5">
            Actualizar Opción
          </h3>
          <hr />
          <div>
            <b-field label="Activo">
              <b-switch v-model="option.is_active" type="is-success"></b-switch>
            </b-field>
            <b-field label="Sugerido">
              <b-switch v-model="option.suggested" type="is-success"></b-switch>
            </b-field>
            <b-field
              label="Position"
              :custom-class="$v.option.position.$error ? 'has-text-danger' : ''"
              :type="{ 'is-danger': $v.option.position.$error }"
              :message="[
                {
                  'Campo requerido':
                    !$v.option.position.required && $v.option.position.$error
                }
              ]"
            >
              <b-input
                v-model="option.position"
                type="number"
                min="0"
              ></b-input>
            </b-field>
          </div>
          <div class="form-group form-row">
            <b-field label="Producto"></b-field>
            <div class="bv-no-focus-ring col">
              <multiselect
                v-model="option.product"
                :options="product_list"
                label="name"
                track-by="id"
                :searchable="true"
                :loading="isLoadingSearch"
                placeholder="Buscar"
                @search-change="getProductList"
                @select="changeProduct"
                :internal-search="false"
                :clear-on-select="false"
                :close-on-select="true"
                :options-limit="300"
                :limit="3"
              >
                <template slot="tag" slot-scope="{ option, remove }">
                  <span class="custom__tag">
                    <span>{{ option.name }}</span>
                    <span class="custom__remove" @click="remove(option)"
                      >❌</span
                    >
                  </span>
                </template>

                <span slot="noResult">No se encontaron coincidencia</span>
              </multiselect>
            </div>
          </div>
          <div v-if="option.product">
            <hr />
            <b-field
              label="Nombre"
              :custom-class="$v.option.name.$error ? 'has-text-danger' : ''"
              :type="{ 'is-danger': $v.option.name.$error }"
              :message="[
                {
                  'Campo requerido':
                    !$v.option.name.required && $v.option.name.$error
                }
              ]"
            >
              <b-input v-model="option.name"></b-input>
            </b-field>
            <b-field
              label="Precio"
              :custom-class="$v.option.price.$error ? 'has-text-danger' : ''"
              :type="{ 'is-danger': $v.option.price.$error }"
              :message="[{ 'Campo requerido': !$v.option.price.required }]"
            >
              <b-input v-model="option.price"></b-input>
            </b-field>
          </div>
          <hr />
          <div
            class="is-flex is-justify-content-flex-end w-full is-align-items-center"
          >
            <div>
              <Button
                variant="gray"
                @click.native="isImageModalActive1 = false"
                >Cerrar</Button
              >
            </div>
            <div class="ml-3">
              <Button
                variant="main"
                :spinner="loading"
                @click.native="submitProductFormOption"
                >Actualizar</Button
              >
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { required, decimal } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import ErrorsDJ from '@/mixins/error'
import Button from '@/components/form/Button'
import ProductService from '@/services/ProductService'
export default {
  name: 'ProductFormOptionItem',
  props: ['productFormOptionItem'],
  components: {
    Multiselect,
    Button
  },
  mixins: [ErrorsDJ],
  data() {
    return {
      option: {
        product: {
          name: this.productFormOptionItem.product_name,
          id: this.productFormOptionItem.product
        },
        name: this.productFormOptionItem.name,
        suggested: this.productFormOptionItem.suggested,
        price: this.productFormOptionItem.price,
        position: this.productFormOptionItem.position,
        is_active: this.productFormOptionItem.is_active
      },
      product_list: [],
      loading: null,
      isLoadingSearch: false,
      loadingDelete: null,
      isImageModalActive1: false,
      isImageModalActive2: false
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      help_text: {
        required
      },
      position: {
        required
      }
    },
    option: {
      position: {
        required
      },
      name: {
        required
      },
      price: {
        required,
        decimal
      },
      producto: {
        required
      }
    }
  },
  methods: {
    changeProduct(value) {
      if (value) {
        this.option.name = value.name
        this.option.price = value.price
      }
    },
    async getProductList(query) {
      this.isLoadingSearch = true
      try {
        const params = {
          query: query,
          id: this.$route.params.id
        }
        const response = await ProductService.getOptionItemList(params)
        this.product_list = response.data
        this.isLoadingSearch = false
      } catch (error) {}
    },
    async submitProductFormOption() {
      this.$v.$touch()
      this.loading = true
      const optionCustom = {}
      Object.assign(optionCustom, this.option)
      if (optionCustom.product) {
        optionCustom.product = optionCustom.product.id
      }
      try {
        const response = await ProductService.putOptionItem(
          this.productFormOptionItem.id,
          optionCustom
        )
        this.loading = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'S',
          msg: 'Se actualizó correctamente.'
        })
        this.$emit('productFormOptionUpdate', response.data)
        this.isImageModalActive1 = false
      } catch (error) {
        this.loading = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'D',
          msg: 'Ocurrió un error.'
        })
      }
    },
    async deleteProductFormOption() {
      this.loadingDelete = true
      try {
        const response = await ProductService.deleteOptionItem(
          this.productFormOptionItem.id
        )
        this.loadingDelete = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'S',
          msg: 'Se eliminó correctamente'
        })
        this.$emit('productFormOptionUpdate', response.data)
        this.isImageModalActive2 = false
      } catch (error) {
        this.loadingDelete = false
        console.error(error)
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'D',
          msg: 'Ocurrió un error.'
        })
      }
    }
  }
}
</script>
